import { IApplicationState } from '../../types/redux';

export const selectAdfoxPuids = (state: IApplicationState) => state.adfox.puids;
